import { createStore } from 'vuex';
import authority from '@/store/modules/authority';
import pageData from '@/store/modules/pageData';
import profile from '@/store/modules/profile';
import createPersistedState from 'vuex-persistedstate';

const store = createStore({
  modules: {
    authority,
    pageData,
    profile,
  },
  plugins: [
    createPersistedState({
      paths: ['authority', 'profile'],
    }),
  ],
});

export default store;
